import {
  ROUTE_APPROVE_USERS,
  ROUTE_APPROVE_GROUPS,
  ROUTE_APPROVE_INDEX,
  ROUTE_APPROVE_MODULES,
  ROUTE_APPROVE_STEPS,
} from "Consts/publicRoutes";

export const SIDENAV_APPROVE_SECTION = {
  text: "Approve",
  userRoute: ROUTE_APPROVE_INDEX,
  restrictedRoute: ROUTE_APPROVE_INDEX,
};

export const SIDENAV_APPROVE_USERS_ROUTE = {
  text: "Users",
  route: ROUTE_APPROVE_USERS,
};

export const SIDENAV_APPROVE_GROUPS_ROUTE = {
  text: "Groups",
  route: ROUTE_APPROVE_GROUPS,
};

export const SIDENAV_APPROVE_MODULES_ROUTE = {
  text: "Modules",
  route: ROUTE_APPROVE_MODULES,
};

export const SIDENAV_APPROVE_STEPS_ROUTE = {
  text: "Steps",
  route: ROUTE_APPROVE_STEPS,
};
